import { StepClass } from '../common';
export var FixedStep;
(function (FixedStep) {
    FixedStep["Welcome"] = "Welcome";
    FixedStep["Exit"] = "Exit";
})(FixedStep || (FixedStep = {}));
export var StudyStatus;
(function (StudyStatus) {
    StudyStatus["Unpublished"] = "UNPUBLISHED";
    StudyStatus["Scheduled"] = "SCHEDULED";
    StudyStatus["Active"] = "ACTIVE";
    StudyStatus["AwaitingReview"] = "AWAITING REVIEW";
    StudyStatus["Paused"] = "PAUSED";
    StudyStatus["Completed"] = "COMPLETED";
})(StudyStatus || (StudyStatus = {}));
export var PrototypeStepType;
(function (PrototypeStepType) {
    PrototypeStepType["Prototype"] = "Prototype";
    PrototypeStepType["FirstClick"] = "FirstClick";
    PrototypeStepType["FreeRoam"] = "FreeRoam";
})(PrototypeStepType || (PrototypeStepType = {}));
export var QuestionStepType;
(function (QuestionStepType) {
    QuestionStepType["Date"] = "Date";
    QuestionStepType["Email"] = "Email";
    QuestionStepType["Numerical"] = "Numerical";
    QuestionStepType["Text"] = "Text";
})(QuestionStepType || (QuestionStepType = {}));
export var DateFormat;
(function (DateFormat) {
    DateFormat["DDMMYYYY"] = "DD-MM-YYYY";
    DateFormat["MMDDYYYY"] = "MM-DD-YYYY";
    DateFormat["YYYYMMDD"] = "YYYY-MM-DD";
})(DateFormat || (DateFormat = {}));
export var YesOrNoStepType;
(function (YesOrNoStepType) {
    YesOrNoStepType["YesNo"] = "YesNo";
    YesOrNoStepType["Legal"] = "Legal";
})(YesOrNoStepType || (YesOrNoStepType = {}));
export var EqualityOperator;
(function (EqualityOperator) {
    EqualityOperator["Is"] = "IS";
    EqualityOperator["IsNot"] = "ISNOT";
})(EqualityOperator || (EqualityOperator = {}));
export var Combinator;
(function (Combinator) {
    Combinator["And"] = "AND";
    Combinator["Or"] = "OR";
})(Combinator || (Combinator = {}));
export var MultipleSelectionMode;
(function (MultipleSelectionMode) {
    MultipleSelectionMode["Unlimited"] = "Unlimited";
    MultipleSelectionMode["ExactNumber"] = "ExactNumber";
    MultipleSelectionMode["Range"] = "Range";
})(MultipleSelectionMode || (MultipleSelectionMode = {}));
export { StepClass };
